import en from './en';

const fr = {
  ...en,
language_label: 'Langue',
    language_english: 'English',
    language_french: 'Francais',
    language_arabic: 'Arabe',
    brand_logo_alt: 'Logo AIV',
    member_status_active: 'Actif',
    member_status_inactive: 'Inactif',
    member_activated: 'Membre active',
    member_deactivated: 'Membre desactive',
    evaluation_delete_confirm: 'Supprimer cette evaluation ? Cette action est irreversible.',
    equipment_delete_confirm: 'Voulez-vous vraiment supprimer cet equipement ?',
    delete_evaluation_failed: "Echec de la suppression de l'evaluation",
    delete_equipment_failed: "Echec de la suppression de l'equipement",
    member_remove_confirm: 'Voulez-vous vraiment retirer {name} ?',
    weekly_insights_count: '{count} insights cette semaine',
    auth_welcome_back_toast: 'Bon retour !',
    auth_logged_out_inactivity: 'Vous avez ete deconnecte en raison de l inactivite.',
    forgot_enter_email_reset: 'Entrez votre e-mail pour recevoir un lien de reinitialisation',
    forgot_reset_link_sent: 'Si l e-mail existe, un lien de reinitialisation a ete envoye',
    forgot_reset_link_failed: 'Impossible d envoyer le lien de reinitialisation',
    insight_weekly_ready: 'Votre insight hebdomadaire est pret.',
    insight_unable_generate: 'Impossible de generer un insight pour le moment.',
    insight_already_generated_week: 'Deja genere cette semaine',
    insight_generate_weekly: 'Generer l insight hebdomadaire',
    club_no_active_selected: 'Aucun club actif selectionne',
    club_updated_simple: 'Club mis a jour',
    club_update_failed: 'Impossible de mettre a jour le club',
    superadmin_failed_load_billing_snapshot: 'Echec du chargement de l apercu de facturation',
    superadmin_failed_load_policies: 'Echec du chargement des politiques',
    superadmin_failed_load_failed_payments: 'Echec du chargement des paiements echoues',
    superadmin_policy_title_required: 'Le titre de la politique est requis',
    superadmin_draft_saved: 'Brouillon enregistre',
    superadmin_could_not_save_draft: 'Impossible d enregistrer le brouillon',
    superadmin_version_required: 'La version est requise',
    superadmin_policy_published: 'Politique publiee',
    superadmin_could_not_publish_policy: 'Impossible de publier la politique',
    nav_dashboard: 'Tableau de bord',
    nav_club: 'Club',
    nav_leaderboard: 'Classement',
    nav_members: 'Membres',
    nav_queue_courts: 'File et Terrains',
    nav_evaluations: 'Evaluations',
    nav_equipment: 'Equipement',
    nav_match_history: 'Historique des matchs',
    nav_daily_report: 'Rapport quotidien',
    nav_profile: 'Profil',
    nav_theme_app: 'Theme et application',
    ui_select_club: 'Selectionner un club',
    ui_logout: 'Se deconnecter',
    role_admin: 'Administrateur',
    role_coach: 'Entraineur',
    role_player: 'Joueur',
    footer_developed_by: 'Developpe par',
    footer_rights: 'Tous droits reserves (c) 2026.',
    login_welcome_back: 'Bon retour',
    login_subtitle: 'Entrez vos identifiants pour acceder a votre compte',
    login_brand_subtitle: 'Club de badminton',
    login_email: 'E-mail',
    login_password: 'Mot de passe',
    login_sign_in: 'Se connecter',
    login_signing_in: 'Connexion...',
    login_forgot_password: 'Mot de passe oublie ?',
    login_no_account: "Vous n'avez pas de compte ?",
    login_create_account: 'Creer un compte',
    login_create_one_here: 'Creez-en un ici',
    login_choose_continue: 'Choisissez comment continuer',
    login_admin_account: 'Compte administrateur',
    login_member_account: 'Compte membre',
    login_verify_sign_in: 'Verifier et se connecter',
    login_verifying_otp: 'Verification du code OTP...',
    login_resend_otp: 'Renvoyer le code OTP',
    signup_title: 'Creez votre compte',
    signup_subtitle: 'Configurez votre club et commencez a gerer les membres',
    signup_first_name: 'Prenom',
    signup_last_name: 'Nom',
    signup_email: 'E-mail',
    signup_password: 'Mot de passe',
    signup_confirm_password: 'Confirmer le mot de passe',
    signup_have_account: 'Vous avez deja un compte ?',
    signup_sign_in: 'Se connecter',
    signup_register_club: 'Inscrire votre club',
    signup_email_verification: "Verification de l'e-mail",
    signup_choose_package: 'Choisissez votre forfait',
    signup_create_admin_account: "Creez le compte administrateur de votre club pour commencer",
    signup_enter_otp_email: "Entrez le code OTP envoye a votre e-mail",
    signup_pick_plan: 'Choisissez le forfait adapte a votre club',
    signup_step_account: 'Compte',
    signup_step_verify: 'Verifier',
    signup_step_package: 'Forfait',
    signup_club_details: 'Details du club',
    signup_required_fields_note: 'Les champs avec * sont obligatoires.',
    signup_club_name: 'Nom de votre club *',
    signup_club_name_placeholder: 'Club de raquette du centre-ville',
    signup_sport_question: 'Quel sport votre club pratique-t-il ? *',
    signup_select_sport: 'Selectionner un sport',
    signup_admin_details: "Details de l'administrateur",
    signup_verify_email: "Verifier l'e-mail",
    signup_otp_code: 'Code OTP',
    signup_otp_verified: 'OTP verifie',
    signup_resend_code: 'Renvoyer le code',
    signup_resend_in: 'Renvoyer dans',
    signup_change_email: "Changer l'e-mail",
    signup_continue: 'Continuer',
    signup_first_last_required: 'Le prenom et le nom sont obligatoires',
    signup_club_required: 'Le nom du club est obligatoire',
    signup_select_sport_required: 'Veuillez selectionner un type de sport',
    signup_email_required: "L'e-mail est obligatoire",
    signup_passwords_mismatch: 'Les mots de passe ne correspondent pas',
    signup_password_requirements: 'Le mot de passe doit respecter toutes les exigences',
    signup_accept_required: 'Veuillez accepter la politique de confidentialite et les conditions pour continuer',
    signup_otp_sent: 'OTP envoye a votre e-mail',
    signup_otp_send_failed: "Impossible d'envoyer l'OTP",
    signup_otp_session_missing: 'Session OTP manquante. Veuillez renvoyer le code OTP.',
    signup_enter_otp: "Entrez le code OTP",
    signup_otp_verification_failed: "Echec de verification OTP",
    signup_email_verified_continue: "E-mail verifie. Cliquez sur Continuer pour poursuivre.",
    signup_verify_email_first: "Veuillez d'abord verifier votre e-mail",
    signup_account_created_login: 'Compte cree. Veuillez vous connecter pour continuer.',
    signup_failed: "Echec de l'inscription",
    signup_creating_account: 'Creation du compte...',
    signup_create_account: 'Creer un compte',
    forgot_title: 'Reinitialisez votre mot de passe',
    forgot_subtitle: 'Nous vous enverrons un lien securise par e-mail.',
    forgot_heading: 'Mot de passe oublie',
    forgot_description: "Entrez l'e-mail associe a votre compte.",
    forgot_check_inbox: 'Verifiez votre boite mail',
    forgot_send_link: 'Envoyer le lien',
    forgot_sending_link: 'Envoi du lien...',
    forgot_resend_in: 'Renvoyer dans',
    forgot_back_login: 'Retour a la connexion',
    forgot_need_help: "Besoin d'aide ? Contactez l'administrateur du club.",
    first_login_setup_subtitle: 'Configurez votre mot de passe pour commencer',
    first_login_title: 'Creez votre mot de passe',
    first_login_desc: 'Choisissez un mot de passe securise',
    first_login_new_password: 'Nouveau mot de passe',
    first_login_confirm_password: 'Confirmer le mot de passe',
    first_login_set_continue: 'Definir le mot de passe et continuer',
    first_login_setting_password: 'Configuration du mot de passe...',
    first_login_invalid_token: 'Jeton invalide ou manquant. Veuillez contacter votre administrateur.',
    first_login_go_login: 'Aller a la connexion',
    first_login_agree_privacy: "J'accepte la",
    first_login_agree_terms: "J'accepte les",
    select_club_title: 'Selectionnez un club',
    select_club_subtitle: 'Choisissez le club a gerer ou dans lequel jouer',
    select_club_loading: 'Chargement des clubs...',
    select_club_failed: 'Echec du chargement des clubs',
    select_club_entering: 'Entree dans le club...',
    select_club_none: "Vous n'etes membre d'aucun club pour le moment.",
    select_club_no_slogan: 'Aucun slogan defini',
    select_club_enter: 'Entrer',
    privacy_notice: "Avis de confidentialite de l'Ontario",
    privacy_title: 'Politique de confidentialite',
    terms_notice: 'Conditions legales',
    terms_title: 'Conditions generales',
    policy_content: 'Contenu de la politique',
    policy_loading_privacy: 'Chargement de la politique de confidentialite...',
    policy_loading_terms: 'Chargement des conditions generales...',
    policy_load_failed: 'Echec du chargement de la politique',
    policy_effective_date: "Date d'entree en vigueur",
    policy_version: 'Version',
    policy_read_terms: 'Lire nos conditions generales',
    policy_view_privacy: 'Voir la politique de confidentialite',
    common_go_back: 'Retour',
    common_back: 'Retour',
    common_cancel: 'Annuler',
    common_loading: 'Chargement...',
    common_processing: 'Traitement...',
    common_remove: 'Retirer',
    common_removing: 'Retrait...',
    common_finish: 'Terminer',
    common_finishing: 'Finalisation...',
    common_error_occurred: "Une erreur s'est produite",
    common_save: 'Enregistrer',
    common_save_apply: 'Enregistrer et appliquer',
    auth_account_setup_required: 'Configuration du compte requise',
    auth_password_reset_required: 'Reinitialisation du mot de passe requise',
    auth_first_time_link_sent: 'Nous avons envoye un lien de premiere configuration a',
    auth_finish_setup_before_signin: 'Ouvrez cet e-mail et terminez la configuration de votre mot de passe avant de vous connecter.',
    auth_password_expired_use_reset: 'Votre mot de passe a expire. Utilisez le lien de reinitialisation envoye a',
    auth_password_expired_suffix: 'pour definir un nouveau mot de passe.',
    auth_request_new_reset_link: 'Demander un nouveau lien',
    auth_2fa_enabled: 'La double authentification est activee pour ce compte.',
    auth_enter_otp_sent_to: 'Entrez le code OTP envoye a',
    auth_otp_code: 'Code OTP',
    auth_enter_code: 'Entrer le code',
    auth_2fa_session_expired: 'Session 2FA expiree. Veuillez vous reconnecter.',
    auth_enter_otp_prompt: 'Entrez le code OTP envoye a votre e-mail',
    auth_otp_failed: 'Echec de verification OTP',
    auth_select_account_continue: 'Selectionnez le compte avec lequel continuer',
    auth_no_usable_accounts: 'Aucun compte utilisable trouve',
    auth_first_login_check_email: 'Verifiez votre e-mail pour le lien de premiere connexion afin de definir votre mot de passe.',
    auth_reset_required_info: 'Votre mot de passe a expire. Demandez un lien de reinitialisation pour continuer.',
    auth_enter_otp_to_complete: "Entrez le code OTP envoye a votre e-mail pour terminer la connexion.",
    auth_login_failed: 'Echec de connexion',
    auth_resend_otp_failed: "Impossible de renvoyer l'OTP",
    auth_otp_resent: 'OTP renvoye a votre e-mail.',
    auth_not_in_club_yet: "Vous n'etes dans aucun club pour le moment. Demandez une invitation a votre admin.",
    auth_continue_account_failed: "Impossible de continuer avec ce compte",
    auth_session_expired_signin_again: 'Session expiree. Veuillez vous reconnecter.',
    auth_session_refresh_failed: 'Echec de rafraichissement de session. Veuillez vous reconnecter.',
    auth_consent_saved: 'Merci. Consentement enregistre.',
    auth_consent_save_failed: "Impossible d'enregistrer votre consentement",
    auth_accept_both_policies: 'Veuillez accepter les deux politiques pour continuer',
    consent_before_continue: 'Avant de continuer',
    consent_review_accept_both: "Veuillez lire et accepter les deux politiques pour acceder a l'application.",
    consent_accept_continue: 'Accepter et continuer',
    consent_saving: 'Enregistrement...',
    first_login_expired_link: "Ce lien de premiere connexion a expire. Veuillez contacter l'administrateur du club pour une nouvelle invitation.",
    first_login_invalid_token_generic: 'Jeton invalide. Veuillez contacter votre administrateur.',
    first_login_password_mismatch: 'Les mots de passe ne correspondent pas',
    first_login_password_requirements: 'Le mot de passe doit respecter toutes les exigences',
    first_login_accept_required: 'Veuillez accepter la politique de confidentialite et les conditions pour continuer',
    first_login_password_set_success: 'Mot de passe defini avec succes. Veuillez vous connecter.',
    first_login_password_set_failed: 'Echec de definition du mot de passe',
    first_login_at_least_8: 'Au moins 8 caracteres',
    first_login_at_least_1_upper: 'Au moins une majuscule',
    first_login_at_least_1_lower: 'Au moins une minuscule',
    first_login_at_least_1_number: 'Au moins un chiffre',
    first_login_at_least_1_special: 'Au moins un caractere special',
    select_club_failed_load: 'Echec du chargement des clubs',
    settings_title: 'Parametres',
    settings_manage_subtitle: "Gerer les parametres de l'application",
    settings_theme_app_title: "Parametres du theme et de l'application",
    settings_theme_app_desc: "Personnalisez l'apparence du menu, le mode de theme, la police et la langue",
    settings_theme_mode: 'Mode de theme',
    settings_light: 'Clair',
    settings_dark: 'Sombre',
    settings_disabled: 'Desactive',
    settings_menu_bg: 'Couleur de fond du menu',
    settings_menu_font: 'Police du menu',
    settings_app_font: "Police de l'application",
    settings_saved: 'Parametres de theme appliques pour ce club.',
    settings_save_failed: "Echec de l'enregistrement des parametres du theme",
    settings_export_success: 'Donnees exportees avec succes!',
    settings_export_failed: "Echec de l'export des donnees",
    package_label_elite: 'Elite (Forfait 3)',
    package_label_pro: 'Pro (Forfait 2)',
    package_label_starter: 'Starter (Forfait 1)',
    pkg_name_starter: 'Starter',
    pkg_name_pro: 'Pro',
    pkg_name_elite: 'Elite',
    pkg_tier_1: 'Forfait 1',
    pkg_tier_2: 'Forfait 2',
    pkg_tier_3: 'Forfait 3',
    pkg_feature_everything_pro: 'Tout ce qui est inclus dans Pro',
    pkg_feature_everything_starter: 'Tout ce qui est inclus dans Starter',
    pkg_feature_250_members: "Jusqu'a 250 membres actifs",
    pkg_feature_150_members: "Jusqu'a 150 membres actifs",
    pkg_feature_50_members: "Jusqu'a 50 membres actifs",
    pkg_feature_multi_admin: 'Roles et permissions avances (plusieurs admins de club)',
    pkg_feature_ui_branding: "Controles UI avances (couleurs/polices pour l'image du club)",
    pkg_feature_logo: 'Televersement/gestion du logo du club',
    pkg_feature_avatar: 'Selection des avatars de profil des membres',
    pkg_feature_ai_chat: "Chat IA pour les insights d'historique de matchs",
    pkg_feature_dashboard_insights: 'Insights de performance actionnables sur le tableau de bord',
    pkg_feature_coach_eval: 'Evaluations des coachs',
    pkg_feature_equipment: "Suivi de l'equipement",
    pkg_feature_ml_limited: 'Analyses limitees assistees par ML pour les tendances cles',
    pkg_feature_daily_advanced: 'Rapports de match quotidiens et tendances avancees du classement',
    pkg_feature_member_mgmt: 'Gestion des membres',
    pkg_feature_queue_courts: "File d'attente et affectation des terrains",
    pkg_feature_basic_leaderboard: 'Historique des matchs et classement de base',
    pkg_feature_basic_dashboard: 'Tableau de bord admin de base',
    pkg_gate_upgrade_plan: 'Mettez a niveau votre forfait',
    pkg_gate_unlock: 'Debloquer',
    pkg_gate_unavailable: "Cette fonctionnalite n'est pas disponible dans votre forfait actuel.",
    pkg_gate_current_plan: 'Votre forfait actuel',
    pkg_gate_upgrade_button: 'Mettre a niveau',
    pkg_gate_elite_only: 'Cette fonctionnalite est disponible uniquement sur Elite (Forfait 3).',
    pkg_gate_available_on: 'Cette fonctionnalite est disponible sur Pro (Package 2) et Elite (Package 3).',
    pkg_gate_contact_admin: "Veuillez contacter l'administrateur du club pour mettre a niveau le forfait et debloquer cette fonctionnalite.",
    pkg_page_title: 'Forfaits',
    pkg_page_subtitle: 'Comparez tous les forfaits et voyez le forfait actif de votre club.',
    pkg_current: 'Actuel',
    pkg_current_plan: 'Forfait actuel',
    pkg_manage_subscription: "Gerer l'abonnement",
    pkg_contact_admin: "Contacter l'admin",
    pkg_month: 'mois',
    pkg_year: 'an',
    pkg_yearly_savings: 'economies annuelles',
    pkg_manage_current_plan: 'Gerer le forfait actuel',
    pkg_upgrade_to_this: 'Passer a ce forfait',
    pkg_contact_admin_changes: "Contactez l'administrateur du club pour les changements de forfait.",
    pkg_need_billing_controls: 'Besoin des controles de facturation ? Ouvrez',
    pkg_billing_admin_only: 'Les controles de facturation sont reserves aux admins du club.',
    pkg_upgrade_request_subject: 'Demande de mise a niveau du forfait',
    profile_evaluations_unavailable_starter: 'Les evaluations ne sont pas disponibles sur Starter (Forfait 1)',
    profile_upgrade_pro_elite_evaluations: 'Passez a Pro ou Elite pour voir l historique des evaluations et les notes par categorie.',
    profile_change_package_from_club_settings: 'Vous pouvez changer le forfait depuis les parametres du club.',
    members_capacity_updated: 'Les membres actifs ont ete mis a jour pour correspondre a la limite de votre forfait.',
    members_capacity_exceed_intro: 'Les membres actifs depassent la limite de votre forfait. Conservez jusqu a',
    members_capacity_active_members_for: 'membres actifs pour',
    members_select_active_title: 'Selectionner les membres actifs',
    members_select_active_desc: 'Votre forfait actuel permet jusqu a {{limit}} membres actifs. Selectionnez ceux qui doivent rester actifs.',
    members_capacity_selected: 'Selectionnes',
    members_capacity_current_active: 'Actifs actuellement',
    members_applying: 'Application...',
    members_apply_selection: 'Appliquer la selection',
    common_close: 'Fermer',
    leaderboard_empty_no_matches: 'Aucun match termine pour generer le classement.',
    leaderboard_empty_search: 'Aucun joueur ne correspond a votre recherche.',
    leaderboard_insights_title: 'Insights du classement',
    leaderboard_insights_availability: 'Les insights avances du classement sont disponibles sur Pro (Package 2) et Elite (Package 3).',
    leaderboard_insights_contact_admin: "Veuillez contacter l'administrateur du club pour mettre a niveau le forfait et debloquer ces insights du classement.",
    leaderboard_select_club: 'Selectionnez un club pour voir le classement.',
    leaderboard_search_placeholder: 'Rechercher par nom de joueur',
    leaderboard_subtitle: "Le classement est base sur la note (evaluation + performance en match).",
    leaderboard_rating: 'Note',
    leaderboard_games: 'Matchs',
    profile_2fa_enabled_label: 'Active (OTP par e-mail requis a la connexion)',
    queue_search_members: 'Rechercher des membres...',
    queue_time_elapsed: 'Temps ecoule :',
    queue_time_in_queue: "Temps dans la file d'attente :",
    queue_clear_title: 'Vider la file ?',
    queue_shuffle_title: 'Melanger la file ?',
    queue_clear_desc: 'Cela supprimera tous les joueurs de la file. Voulez-vous vraiment reinitialiser la file ?',
    queue_shuffle_desc: "Cela melangera l'ordre actuel de la file. Voulez-vous vraiment melanger la file ?",
    queue_yes_continue: 'Oui, continuer',
    queue_add_to_queue: 'Ajouter a la file',
    queue_no_players_match_search: 'Aucun joueur ne correspond a votre recherche.',
    queue_no_players_in_queue: "Aucun joueur dans la file d'attente.",
    queue_no_members_match_search: 'Aucun membre ne correspond a votre recherche.',
    queue_no_members_available_to_add: 'Aucun membre disponible a ajouter.',
    queue_full_limit: 'La file est pleine (limite : {{limit}}).',
    queue_available: 'Disponible',
    queue_in_progress: 'En cours',
    queue_coach: 'Entraineur',
    queue_admin: 'Administrateur',
    queue_no_prior_head_to_head: 'Aucun historique face a face',
    queue_head_to_head_summary: '{{winners}} ont gagne {{pct}}% ({{wins}}/{{total}}) du temps contre {{losers}}',
    queue_remove_from_queue_title: 'Retirer de la file ?',
    queue_remove_from_queue_desc: 'Vous etes sur le point de retirer {{name}} de la file. Voulez-vous continuer ?',
    match_history_view_all_shown: 'Voir tous les matchs termines ({{total}} affiches)',
    match_history_view_yours_shown: 'Voir vos matchs termines ({{total}} affiches)',
    members_import_csv_help_prefix: 'Televersez un CSV avec les en-tetes :',
    club_logo_locked_until_edit: "Le logo est verrouille tant que vous n'activez pas la modification du club",
    queue_match_notes_placeholder: 'Ajoutez des notes sur le match...',
    leaderboard_won: 'Gagnes',
    leaderboard_lost: 'Perdus',
    leaderboard_points_earned: 'Points marques',
    leaderboard_points_lost: 'Points encaisses',
    leaderboard_pd: 'Difference de points (PD)',
    leaderboard_rank: 'Rang',
    leaderboard_player: 'Joueur',
    leaderboard_points: 'Points',
    leaderboard_scored: 'Marques',
    leaderboard_against: 'Contre',
    leaderboard_you: 'Vous',
    leaderboard_reevaluate: 'Reevaluer',
    leaderboard_showing: 'Affichage',
    leaderboard_of: 'sur',
    leaderboard_rating_improved: 'Note amelioree',
    leaderboard_rating_decreased: 'Note diminuee',
    dashboard_eval_analytics: "Analyses d'evaluation",
    dashboard_rank_analytics: 'Analyses du classement',
    dashboard_profile_analytics: 'Analyses du profil',
    dashboard_visual_unavailable: 'Visuel indisponible',
    dashboard_locked_in_starter: 'Verrouille dans Starter',
    dashboard_current_plan: 'Forfait actuel',
    dashboard_available_in_pro_elite: 'Disponible dans Pro et Elite',
    dashboard_eval_progress: "Progression de l'evaluation dans le temps",
    dashboard_eval_hint: "Suivez les tendances de note a mesure que de nouvelles evaluations sont ajoutees.",
    dashboard_eval_progress_tooltip: "La ligne moyenne montre la tendance globale des evaluations. Activez ou desactivez les categories pour cibler les points forts ou les lacunes.",
    dashboard_average: 'Moyenne',
    dashboard_technical: 'Technique',
    dashboard_movement: 'Mouvement',
    dashboard_tactical: 'Tactique',
    dashboard_physical: 'Physique',
    dashboard_psychological: 'Psychologique',
    dashboard_waiting_for_evaluations: "En attente d'evaluations.",
    dashboard_club_matches: 'Matchs du club',
    dashboard_completed_matches_selected_club: 'Matchs termines dans le club selectionne',
    dashboard_avg_matches_per_court_day: 'Moy. matchs par terrain / jour',
    dashboard_avg_active_courts_day: 'Moy. terrains actifs / jour',
    dashboard_completed_matches_divided_by_courts: 'Matchs termines divises par le nombre de terrains sur les jours actifs',
    dashboard_avg_queue_wait_min: "Moy. attente dans la file (min)",
    dashboard_from_club_queue_sessions: 'A partir des sessions de file du club',
    dashboard_avg_match_duration: 'Duree moyenne des matchs',
    dashboard_average_duration_completed_club_matches: 'Duree moyenne des matchs termines du club',
    dashboard_my_matches_today: "Mes matchs aujourd'hui",
    dashboard_queue_status: 'Statut dans la file',
    dashboard_total_members: 'Total des membres',
    dashboard_no_active_matches_now: "Aucun match actif pour le moment.",
    dashboard_matches_played_today: "Matchs joues aujourd'hui",
    dashboard_wins_losses_by_day: 'Victoires et defaites par jour',
    dashboard_wins_losses_tooltip: 'Affiche vos resultats de match quotidiens pour la periode selectionnee.',
    dashboard_points_scored_vs_lost_day: 'Points marques vs points encaisses par jour',
    dashboard_points_chart_tooltip: 'Points marques et encaisses chaque jour pour la periode selectionnee.',
    dashboard_no_completed_matches_chart: 'Aucun match termine a afficher dans le graphique pour le moment.',
    dashboard_no_leaderboard_history: 'Aucun historique de classement pour le moment.',
    dashboard_not_enough_match_data_pie: 'Pas assez de donnees de match pour le graphique circulaire.',
    dashboard_evaluation_data_unavailable: "Les donnees d'evaluation ne sont pas encore disponibles.",
    dashboard_queue_history_unavailable: "L'historique de la file d'attente n'est pas encore disponible.",
    dashboard_no_completed_matches_heatmap: 'Aucun match termine pour generer la carte thermique.',
    dashboard_7d_avg: 'Moy. 7j',
    dashboard_rank_last_days: 'Rang au classement ({{days}} derniers jours)',
    dashboard_rank_tooltip: "Votre position au classement selon les evaluations et les resultats de match sur la periode selectionnee.",
    dashboard_rank_30d: 'Rang au classement (30 jours)',
    dashboard_rank_hint: "Voyez comment votre classement evolue au fil du temps une fois les matchs enregistres.",
    dashboard_club_matches_by_selection_mode: 'Matchs du club par mode de selection ({{days}} derniers jours)',
    dashboard_selection_mode_tooltip: 'Repartition des matchs par mecanisme de selection sur la meme periode que le graphique empile.',
    dashboard_my_evaluation_profile: "Mon profil d'evaluation",
    dashboard_evaluation_profile_tooltip: 'Affiche votre score moyen par categorie d evaluation.',
    dashboard_profile_hint: 'Consultez votre profil de competences par categorie et identifiez vos points forts et axes d amelioration.',
    dashboard_queue_wait_distribution: "Repartition du temps d'attente dans la file",
    dashboard_queue_distribution_tooltip: "Repartition des durees des sessions de file dans des tranches de temps d'attente.",
    dashboard_queue_sessions: 'Sessions de file',
    dashboard_court_usage_day_of_week: 'Utilisation des terrains par jour de semaine',
    dashboard_court_usage_tooltip: 'Chaque case montre combien de matchs termines ont ete joues sur un terrain pour un jour de la semaine.',
    dashboard_court: 'Terrain',
    dashboard_court_number: 'Terrain {{court}}',
    dashboard_court_match_count_title: 'Terrain {{court}} {{day}} : {{count}} {{matchWord}}',
    dashboard_match_singular: 'match',
    dashboard_match_plural: 'matchs',
    dashboard_price_label: 'Prix',
    queue_need_more_players: 'Il faut encore {{count}} joueurs dans la file',
    common_prev: 'Prec',
    common_next: 'Suiv',
    common_page: 'Page',
    landing_nav_features: 'Fonctionnalites',
    landing_nav_showcase: 'Demonstration',
    landing_nav_pricing: 'Tarifs',
    landing_nav_contact: 'Contact',
    landing_brand_subtitle: 'Intelligence sports de raquette',
    landing_login: 'Connexion',
    landing_start_free: 'Commencer gratuitement',
    landing_hero_member_eyebrow: 'Gestion des membres',
    landing_hero_member_title: 'Rassemblez joueurs, coachs et admins dans un seul systeme de club bien organise.',
    landing_hero_member_desc: 'Gerez les invitations, les imports CSV, les acces et la premiere connexion depuis un workflow de membres pense pour les clubs de sports de raquette.',
    landing_hero_create_club: 'Creer votre club',
    landing_hero_see_pricing: 'Voir les tarifs',
    landing_hero_stats_eyebrow: 'Stats et classement',
    landing_hero_stats_title: 'Transformez l activite quotidienne du club en rapports, classements et insights exploitables.',
    landing_hero_stats_desc: 'Suivez les mouvements du classement, l historique des matchs, les evaluations, les rapports quotidiens et les analyses depuis une vue performance claire.',
    landing_hero_explore_features: 'Explorer les fonctionnalites',
    landing_hero_watch_demo: 'Voir la demo',
    landing_hero_queue_eyebrow: 'File et gestion des matchs',
    landing_hero_queue_title: 'Pilotez la file, l affectation des terrains et les matchs depuis une seule vue en direct.',
    landing_hero_queue_desc: 'Gardez les sessions fluides avec plusieurs modes d affectation, une file visible en direct, des rotations equilibrees et une cloture de match propre.',
    landing_hero_compare_packages: 'Comparer les forfaits',
    landing_hero_contact_us: 'Nous contacter',
    landing_hero_go_to_slide: 'Aller a la diapositive',
    landing_hero_prev_slide: 'Diapositive precedente',
    landing_hero_next_slide: 'Diapositive suivante',
    landing_hero_pause: 'Mettre le diaporama en pause',
    landing_hero_play: 'Lancer le diaporama',
    landing_features_badge: 'Fonctionnalites clees',
    landing_features_title: 'Tout ce dont votre club a besoin',
    landing_features_desc: 'Concu specialement pour les clubs de sports de raquette, de la gestion des membres aux analyses de match.',
    landing_feature_members_title: 'Gestion des membres',
    landing_feature_members_text: 'Rassemblez joueurs, coachs et admins dans un systeme membre bien structure avec un onboarding fluide, des acces clairs et une organisation qui evolue avec votre club.',
    landing_feature_members_bullet_1: 'Onboarding individuel et import en masse',
    landing_feature_members_bullet_2: 'Gestion des roles et des acces',
    landing_feature_members_bullet_3: 'Flux d invitation pour la premiere connexion',
    landing_feature_queue_title: 'File et terrains',
    landing_feature_queue_text: 'Gerez la file et l affectation des terrains depuis une interface unique concue pour les sessions chargees, les rotations equilibrees et des operations de match fluides.',
    landing_feature_queue_bullet_1: 'Visibilite en direct de la file',
    landing_feature_queue_bullet_2: 'Plusieurs modes d affectation',
    landing_feature_queue_bullet_3: 'Fin de match et mise a jour automatique de la file',
    landing_feature_stats_title: 'Stats et insights',
    landing_feature_stats_text: 'Transformez l activite du club en visibilite claire avec historique des matchs, evolution du classement, rapports, evaluations et insights fournis par l IA, faciles a exploiter.',
    landing_feature_stats_bullet_1: 'Suivi du classement et historique des matchs',
    landing_feature_stats_bullet_2: 'Rapports quotidiens et insights hebdomadaires',
    landing_feature_stats_bullet_3: 'Evaluations et analyses de performance',
    landing_benefits_badge: 'Pourquoi nous choisir',
    landing_benefits_title: 'Concu pour les clubs modernes de sports de raquette',
    landing_benefits_desc: 'Un systeme d exploitation cible pour les clubs qui veulent plus de structure, de rapidite et de controle sur les membres, terrains, matchs et rapports.',
    landing_benefit_1_title: 'Pense pour les sessions en direct',
    landing_benefit_1_text: 'Gardez les membres, la file, les terrains et les matchs en mouvement sans friction operationnelle.',
    landing_benefit_2_title: 'Concu pour le vrai travail du club',
    landing_benefit_2_text: 'Concu autour du fonctionnement reel des clubs, avec des outils utiles au quotidien plutot qu un logiciel administratif generique.',
    landing_benefit_3_title: 'Pret pour les operations quotidiennes',
    landing_benefit_3_text: 'Couvrez onboarding, gestion des matchs, rapports et suivi de performance depuis une seule plateforme fiable.',
    landing_showcase_badge: 'Demonstration',
    landing_showcase_title: 'Voyez Smashlytics en action',
    landing_showcase_desc: 'Decouvrez comment la plateforme simplifie la gestion du club avec des workflows clairs et efficaces.',
    landing_showcase_1_title: 'Creation et gestion du club',
    landing_showcase_1_text: 'Creez un club, mettez a jour les details essentiels, configurez les terrains, les horaires et gardez les parametres operationnels alignes des le premier jour.',
    landing_showcase_2_title: 'Gestion des membres',
    landing_showcase_2_text: 'Ajoutez des membres un par un ou en masse, gerez les roles, modifiez les profils et gardez un roster de club bien organise.',
    landing_showcase_3_title: 'File, terrains et matchs',
    landing_showcase_3_text: 'Gerez la file en direct, affectez les terrains, equilibrez les rotations et terminez les matchs depuis un flux de controle clair.',
    landing_showcase_4_title: 'Evaluations',
    landing_showcase_4_text: 'Ajoutez et modifiez les evaluations des joueurs, suivez les categories de note et gardez un retour coach structure et consultable.',
    landing_showcase_5_title: 'Historique et rapports quotidiens',
    landing_showcase_5_text: 'Consultez les matchs termines, les resumes journaliers et des vues de reporting qui rendent l activite du club facile a comprendre.',
    landing_showcase_6_title: 'Gestion du profil',
    landing_showcase_6_text: 'Mettez a jour les informations personnelles, les preferences du compte et les donnees visibles par les membres depuis un flux profil clair.',
    landing_showcase_7_title: 'Gestion de l equipement',
    landing_showcase_7_text: 'Gerez l equipement du club, gardez les fiches materiel organisees et rattachez l equipement utilise a la fin des matchs.',
    landing_showcase_8_title: 'Theme, image et langue',
    landing_showcase_8_text: 'Personnalisez l apparence du club, gerez le theme et changez la langue de la plateforme selon votre mode de fonctionnement.',
    landing_open_walkthrough: 'Ouvrir la presentation',
    landing_watch_demo: 'Voir la demo',
    landing_pricing_badge: 'Tarifs',
    landing_pricing_title: 'Choisissez votre forfait',
    landing_pricing_desc: 'Selectionnez le plan adapte a votre club et faites evoluer votre organisation au fil de votre croissance.',
    landing_pricing_most_popular: 'Le plus populaire',
    landing_pricing_save_yearly: 'Economisez {{pct}}% avec la facturation annuelle',
    landing_pricing_choose_plan: 'Choisir {{name}}',
    landing_pricing_starter_desc: 'Pour les clubs qui ont besoin d une base operationnelle claire.',
    landing_pricing_pro_desc: 'Pour les clubs etablis qui veulent une meilleure visibilite de performance.',
    landing_pricing_elite_desc: 'Pour les clubs qui veulent plus de controle, de personnalisation et d outils IA.',
    landing_pkg_feature_ml_advanced: 'Analyses avancees assistees par ML pour les tendances cles de performance',
    landing_cta_title: 'Donnez a votre club un seul systeme pour les membres, les terrains, les matchs et les insights.',
    landing_cta_desc: 'Lancez-vous avec une organisation plus propre, reduisez la friction admin et offrez aux joueurs, coachs et responsables de club une experience plus professionnelle des le premier jour.',
    landing_cta_button: 'Creer votre club',
    landing_contact_badge: 'Contact',
    landing_contact_title: 'Parlons de la bonne configuration pour votre club.',
    landing_contact_desc: 'Que vous lanciez une nouvelle structure, remplaciez des processus admin disperses ou cherchiez a mieux organiser membres, terrains, rapports et analyses, nous pouvons vous aider a choisir le bon forfait et la bonne mise en place.',
    landing_contact_best_fit_title: 'Ideal pour',
    landing_contact_best_fit_desc: 'Les clubs qui veulent un systeme plus structure pour la gestion des membres, la file, l affectation des terrains, les rapports, les evaluations et les insights.',
    landing_contact_discuss_title: 'Sujets a discuter',
    landing_contact_discuss_1: 'Orientation sur les forfaits Starter, Pro et Elite',
    landing_contact_discuss_2: 'Migration des membres, onboarding et structure des acces',
    landing_contact_discuss_3: 'Mise en place des terrains, des regles de file, des rapports et des workflows coach',
    landing_footer_subtitle: 'Systeme d intelligence sports de raquette',
    landing_footer_desc: 'Smashlytics reunit la gestion des membres, le flux terrain, les rapports et la visibilite de performance dans un seul systeme clair pour les structures modernes de sports de raquette.',
    landing_footer_platform: 'Plateforme',
    landing_footer_access: 'Acces',
    landing_footer_signup: 'Inscription',
    landing_footer_talk: 'Nous contacter',
    landing_footer_note: 'Pour les clubs qui veulent un modele operationnel plus propre.',
    landing_footer_copyright: '© {{year}} Smashlytics. Concu pour les structures modernes de sports de raquette.',
} as const;

export default fr;
